import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function BreakdownReasonGroup(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_5"
            options={props.breakdownReasonGroupData}
            //renderTags={() =>{}}
            limitTags={5}
            value={props.breakdownReasonGroupData.filter((item) => props.breakdownReasonGroup?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.breakdownReasonGroupLocalizationName ?? option.name}
            renderInput={(params) => <TextField id="bl_table_TextField_4" {...params} margin="normal" label={t("BreakdownGroup")} variant="outlined" size="small" />}
            onChange={(event, newValue) => {
                props.HandleBreakdownReasonGroup(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.breakdownReasonGroupLocalizationName ?? option.name}</li>}
            size={props.size ?? "normal"}
        />
    );
}
